import React from 'react';

import { NO_DATA_FOUND } from '../../../../static/constants.js';
import { messageManager } from '../../../System/messageManager/messageManager.js';
import GeneralEmptyState from '../GeneralEmptyState/GeneralEmptyState.js';
import { useNavigate } from 'react-router';
import { NAVIGATION_PATHS } from '../../../../static/navigationPaths.js';
import PropTypes from 'prop-types';


const NoProgramsEmptyState = ({nameConventions}) => {
  const navigate = useNavigate();

  return (
    <GeneralEmptyState
      src={NO_DATA_FOUND.source}
      alt={NO_DATA_FOUND.alt}
      title={messageManager(nameConventions).NO_PROGRAMS_EMPTY_STATE.NO_PROGRAMS_FOR_BUDGET_MESSAGE}
      showButton={true}
      handleClick={() => navigate(`../${NAVIGATION_PATHS.PROGRAM_INVENTORY}`)}
      buttonTitle={messageManager(nameConventions).NO_PROGRAMS_EMPTY_STATE.ADD_PROGRAMS}
    />
  );
};

NoProgramsEmptyState.propTypes = {
  nameConventions: PropTypes.object
};

export default NoProgramsEmptyState;
